export enum TwoFactorType {
  None = 0,
  Email = 1,
}
